const REGEX_SPECIAL_CHARS = (/[-[\]{}()*+?.,\\^$|#\s]/g);

export function escapeRegexSpecialChars(value: string): string {
	return value.replace(REGEX_SPECIAL_CHARS, '\\$&');
}
